import {isFeatureEnabled} from '@github-ui/feature-flags'

export function getIssueTitle(title: string, titleHTML: string): string {
  const prohibitFallback = isFeatureEnabled('issues_react_prohibit_title_fallback')
  if (prohibitFallback) {
    return titleHTML
  }
  return titleHTML || title
}
